// extracted by mini-css-extract-plugin
export default {"searchForm":"SearchForm_searchForm__2CV4y","searchInput":"SearchForm_searchInput__t8p-O"};